import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '商务合作',
    items: [
      { name: '广告投放', href: '/about' },
      { name: '品牌推广', href: '/about' },
      { name: '内容合作', href: '/about' },
    ],
  },
  {
    title: '侵权投诉',
    items: [
      { name: '版权投诉', href: '/about' },
      { name: '内容下架', href: '/about' },
      { name: '律师函接收', href: '/about' },
    ],
  },
  {
    title: '联系邮箱',
    items: [
      { name: 'hello@wjf5l.cn', href: 'mailto:hello@wjf5l.cn' },
      { name: 'hello@wjf5l.cn', href: 'mailto:hello@wjf5l.cn' },
    ],
  },
];

const socialIcons = [
  { name: '微博', icon: 'ri-weibo-line', href: '#' },
  { name: '抖音', icon: 'ri-tiktok-line', href: '#' },
  { name: '小红书', icon: 'ri-bookmark-line', href: '#' },
  { name: '微信', icon: 'ri-wechat-line', href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-background-950">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-18">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1 max-w-sm">
            <Link
              to="/"
              className="text-2xl md:text-3xl font-heading font-black text-foreground-50 tracking-wider"
            >
              爆料吃瓜
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              爆料吃瓜网致力于为全网吃瓜群众提供最新、最快、最全的娱乐八卦资讯。覆盖明星八卦、网红黑料、综艺爆料、影视吃瓜等多个领域，每日同步更新独家爆料与吃瓜资源。
            </p>
            <div className="flex items-center gap-4 mt-6">
              {socialIcons.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-secondary-600 flex items-center justify-center text-foreground-400 hover:text-accent-400 hover:border-accent-500 transition-all duration-200"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-wrap gap-10 lg:gap-16">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-4">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2">
                  {group.items.map((item) => (
                    <li key={item.name}>
                      {item.href.startsWith('mailto:') ? (
                        <a
                          href={item.href}
                          className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200"
                        >
                          {item.name}
                        </a>
                      ) : (
                        <Link
                          to={item.href}
                          className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200"
                        >
                          {item.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:ml-auto">
            <div className="w-28 h-28 bg-secondary-800 rounded-lg flex items-center justify-center">
              <i className="ri-qr-code-line text-4xl text-foreground-400"></i>
            </div>
            <p className="text-xs text-foreground-500 mt-2 text-center">扫码下载App</p>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800/40">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 爆料吃瓜网 版权所有
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">
              免责声明
            </Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">
              隐私政策
            </Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">
              投稿指南
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}